import { dismissToast, pauseToast, resumeToast, useToasts } from './toast';

export function Toasts() {
  const items = useToasts();
  return (
    <div className="toasts" role="status" aria-live="polite">
      {items.map((x) => (
        <div
          key={x.id}
          className={`toast ${x.tone === 'error' ? 'error' : ''} ${x.leaving ? 'leaving' : ''}`}
          onPointerEnter={() => pauseToast(x.id)}
          onPointerLeave={() => resumeToast(x.id)}
        >
          <span>{x.text}</span>
          {x.action && (
            <button
              type="button"
              onClick={() => {
                x.action!.onClick();
                dismissToast(x.id);
              }}
            >
              {x.action.label}
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
